/* PD product page: rows → slide-out panel (design 5a), rows under the gallery on desktop,
   brand logo in the brand pill (same logo files as the product feed), and the split of the
   PD-Garage fitment card: its Produktinfo zone moves into the theme's box under Add to cart.
   Theme hooks into the app block (fitment-confirm.liquid): .fc-card[data-fitment-status],
   [data-fitment-product-info] (.fc-spec), [data-fc-position]. Every lookup happens at call
   time so theme-editor re-renders (shopify:section:load) and product swaps stay correct. */
(function () {
  "use strict";
  if (window.__pdProductBooted) return; window.__pdProductBooted = true;   // loaded by both the rows section and the Produktinfo snippet
  function ready(fn) { if (document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }
  var q = function (s) { return document.querySelector(s); };
  ready(function () {
    var mq = window.matchMedia("(min-width: 1024px)");

    /* ---- desktop: rows live under the gallery (left column) ---- */
    var designMode = !!(window.Shopify && window.Shopify.designMode);   // theme editor: a section nested inside another section reads as "broken HTML in main-product.liquid"
    function place() {
      if (designMode) return;
      var rows = q("[data-pd-prows]"), section = rows && rows.closest(".shopify-section"), media = q(".product__media-wrapper");
      if (!section || !media || !document.contains(section)) return;
      if (mq.matches) { if (section.parentElement !== media) media.appendChild(section); }
      else { var main = q('.shopify-section[id*="__main"]'); if (main && section.parentElement !== main.parentElement) main.insertAdjacentElement("afterend", section); }
    }
    place(); mq.addEventListener("change", place);

    /* ---- slide-out panel ---- */
    var closeLabel = (q("[data-pd-prows]") || {}).dataset ? (q("[data-pd-prows]").dataset.closeLabel || "Close") : "Close";
    var panel = document.createElement("div");
    panel.className = "pd-panel"; panel.hidden = true;
    panel.innerHTML = '<div class="pd-panel__overlay" data-pd-panel-close><span hidden></span></div><aside class="pd-panel__box" role="dialog" aria-modal="true" aria-labelledby="PdPanelTitle"><div class="pd-panel__head"><h2 class="pd-panel__title" id="PdPanelTitle"></h2><button type="button" class="pd-panel__close" data-pd-panel-close aria-label="' + closeLabel + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="pd-panel__body" data-pd-panel-body></div></aside>';
    document.body.appendChild(panel);
    var titleEl = panel.querySelector(".pd-panel__title"), bodyEl = panel.querySelector("[data-pd-panel-body]");
    var current = null, lastFocus = null;   // current = the hidden source panel whose children are on loan
    function open(btn) {
      var src = document.getElementById(btn.getAttribute("aria-controls")); if (!src) return;
      if (current && current !== src) restore();
      titleEl.textContent = src.dataset.title || btn.textContent.trim();
      while (src.firstChild) bodyEl.appendChild(src.firstChild);   // move (not clone): keeps live widgets (e-mærket) working
      current = src; lastFocus = btn; btn.setAttribute("aria-expanded", "true");
      panel.hidden = false; requestAnimationFrame(function () { panel.classList.add("is-open"); });
      document.body.classList.add("pd-panel-open");
      panel.querySelector(".pd-panel__close").focus({ preventScroll: true });
    }
    function restore() { if (!current) return; while (bodyEl.firstChild) current.appendChild(bodyEl.firstChild); var b = q('[aria-controls="' + current.id + '"]'); if (b) b.setAttribute("aria-expanded", "false"); current = null; }
    function close() {
      panel.classList.remove("is-open"); document.body.classList.remove("pd-panel-open");
      setTimeout(function () { panel.hidden = true; restore(); }, 280);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-pd-prow]"); if (btn) { e.preventDefault(); open(btn); return; }
      if (e.target.closest("[data-pd-panel-close]")) close();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) close(); });

    /* ---- Produktinfo box: the fitment card's spec zone (EAN / approvals / OEM, filled async
       by the app) moves under Add to cart; the fits-position is mirrored as a row. ---- */
    function syncPos() {
      var card = q(".fc-card"), row = q("[data-pd-pinfo] [data-pd-pinfo-pos]");
      if (!card || !row) return;
      var pos = card.getAttribute("data-fitment-status") === "fits" ? ((card.querySelector("[data-fc-position]") || {}).textContent || "").trim() : "";
      row.querySelector("dd").textContent = pos; row.hidden = !pos;
    }
    /* Certifikater: selve godkendelsen ER linket — blåt og understreget — i stedet for et
       "Se certifikat" bagefter (merchant 2026-09-24). Appen tegner chippen og dokumentlinket som
       søskende; her flyttes chippens indhold over i et <a> med linkets href, og linket fjernes.
       Nummeret pakkes i sin egen span, så understregningen ikke også løber under det grønne flueben.
       Kører igen hver gang appen fylder boksen (den henter asynkront), og er idempotent: efter
       første kørsel findes der ingen .fc-spec__doc mere. */
    function certLinks(root) {
      (root || document).querySelectorAll("a.fc-spec__doc").forEach(function (doc) {
        var chip = doc.previousElementSibling;
        if (!chip || !chip.classList.contains("fc-spec__chip") || chip.tagName === "A") return;
        var a = document.createElement("a");
        a.className = chip.className + " fc-spec__chip--doc";
        a.href = doc.getAttribute("href"); a.target = "_blank"; a.rel = "noopener noreferrer";
        while (chip.firstChild) {
          var n = chip.firstChild;
          if (n.nodeType === 3 && n.textContent.trim()) {
            var sp = document.createElement("span"); sp.className = "fc-spec__num"; sp.textContent = n.textContent;
            chip.removeChild(n); a.appendChild(sp);
          } else a.appendChild(n);
        }
        chip.parentNode.replaceChild(a, chip);
        var pad = doc.previousSibling;
        if (pad && pad.nodeType === 3 && !pad.textContent.trim()) pad.parentNode.removeChild(pad);
        doc.parentNode.removeChild(doc);
      });
    }

    var obs = null, obsCard = null, specObs = null, specNode = null;
    function placeInfo() {
      var slot = q("[data-pd-pinfo] [data-pd-pinfo-app]"), spec = q("[data-fitment-product-info]");
      if (slot && spec && spec.parentElement !== slot) slot.appendChild(spec);   // move, not clone: the app keeps its reference and fills it later
      if (spec && spec !== specNode && window.MutationObserver) {
        if (specObs) specObs.disconnect();
        specObs = new MutationObserver(function () { certLinks(spec); });
        specObs.observe(spec, { childList: true, subtree: true });
        specNode = spec;
      }
      certLinks(spec || document);
      var card = q(".fc-card");
      if (card && card !== obsCard && window.MutationObserver) {
        if (obs) obs.disconnect();
        obs = new MutationObserver(syncPos); obs.observe(card, { attributes: true, attributeFilter: ["data-fitment-status"] }); obsCard = card;
      }
      syncPos();
    }
    placeInfo();
    /* theme editor: the rows section sits inside the product section on desktop, so an editor
       re-render of the product section wipes it → fetch the section back and re-place it */
    var rowsSectionId = (function () { var r = q("[data-pd-prows]"), s = r && r.closest(".shopify-section"); return s ? s.id.replace(/^shopify-section-/, "") : ""; })();
    document.addEventListener("shopify:section:load", function () {
      place(); placeInfo();
      if (designMode || q("[data-pd-prows]") || !rowsSectionId || !window.fetch) return;
      fetch(location.pathname + "?section_id=" + encodeURIComponent(rowsSectionId), { credentials: "same-origin" }).then(function (r) { return r.ok ? r.text() : ""; }).then(function (html) {
        if (!html || q("[data-pd-prows]")) return;
        var doc = new DOMParser().parseFromString(html, "text/html"), fresh = doc.querySelector(".shopify-section");
        var main = q('.shopify-section[id*="__main"]');
        if (fresh && main) { main.insertAdjacentElement("afterend", document.adoptNode(fresh)); place(); }
      }).catch(function () {});
    });
    window.addEventListener("fitment:garage-updated", syncPos);

    /* variant change (Hyper pubsub): keep the item number + the app's SKU in step; the app
       re-inits through FitmentWidgets.mount when that hook is deployed. */
    function onVariant(ev) {
      var v = ev && ((ev.data && ev.data.variant) || ev.variant); if (!v || !v.sku) return;
      var sku = q("[data-pd-pinfo-sku]"), card = q(".fc-card"), spec = q("[data-fitment-product-info]");
      if (sku) sku.textContent = v.sku;
      if (card) card.dataset.sku = v.sku;
      if (spec) spec.dataset.sku = v.sku;
      if (window.FitmentWidgets && typeof window.FitmentWidgets.mount === "function") window.FitmentWidgets.mount(document);
      placeInfo();
    }
    function hookVariant() {
      var ps = window.FoxTheme && window.FoxTheme.pubsub;
      if (ps && ps.subscribe && ps.PUB_SUB_EVENTS && ps.PUB_SUB_EVENTS.variantChange) { ps.subscribe(ps.PUB_SUB_EVENTS.variantChange, onVariant); return true; }
      return false;
    }
    if (!hookVariant()) window.addEventListener("load", hookVariant);

    /* ---- product gate: reveal the page when the gallery image and the fitment card are in ---- */
    (function gateProduct() {
      var style = q("style[data-pd-gate]"), spin = q("[data-pd-gate-spinner]");
      if (!style) { if (spin) spin.remove(); return; }
      var t0 = Date.now(), done = false;
      function reveal() {
        if (done) return; done = true;
        setTimeout(function () {
          if (spin) spin.classList.add("is-done");
          setTimeout(function () {
            style.remove(); if (spin) spin.remove();
            var secs = Array.prototype.slice.call(document.querySelectorAll("#MainContent > .shopify-section"));
            secs.forEach(function (el) { el.classList.add("pd-revealed"); });
            setTimeout(function () { secs.forEach(function (el) { el.classList.remove("pd-revealed"); }); }, 700);
          }, 180);
        }, Math.max(0, 350 - (Date.now() - t0)));
      }
      var img = q(".product__media-gallery-viewer img, .product__media-item img, .product__media-wrapper img");
      var imgReady = new Promise(function (r) { if (!img || img.complete) return r(); img.addEventListener("load", r); img.addEventListener("error", r); setTimeout(r, 2500); });
      var card = q(".fc-card");
      var fitReady = new Promise(function (r) { if (!card || card.getAttribute("data-fitment-status") !== "loading") return r(); var mo = new MutationObserver(function () { if (card.getAttribute("data-fitment-status") !== "loading") { mo.disconnect(); r(); } }); mo.observe(card, { attributes: true, attributeFilter: ["data-fitment-status"] }); setTimeout(function () { mo.disconnect(); r(); }, 2500); });
      Promise.all([imgReady, fitReady]).then(reveal);
      setTimeout(reveal, 6000);
    })();

    /* gallery: the arrows wrap around instead of stopping at the last photo (merchant 2026-09-11).
       The theme's Swiper is initialised without loop, and turning that on after the fact is not
       reliable — so at the end we simply jump to the other end. */
    (function () {
      /* Hyper disables the arrow on the last slide, and a disabled button fires no click. An earlier
         version stripped that attribute from a MutationObserver — Swiper put it straight back and the
         two fought in an endless loop that froze the page. Instead we never touch the button: we watch
         pointerdown on the gallery and act on the COORDINATES, which still reach the container even
         when the button itself is disabled. */
      /* the swiper is created after us, so look it up at CLICK time, not now */
      var findSw = function () { var v = q(".product__media-gallery-viewer") || q("media-gallery .swiper:not(.product__media-gallery-thumbails)"); return v && v.swiper ? v : null; };
      /* Hyper's arrows are <button class="swiper-button"> with an aria-label, one pair per swiper —
         take the pair that belongs to the big viewer (its own gallery), not the thumbnails. */
      document.addEventListener("pointerdown", function (e) {
        var viewer = findSw(); if (!viewer) return;
        var sw = viewer.swiper;
        var gallery = viewer.closest("media-gallery") || viewer.parentElement;
        if (!gallery || !gallery.contains(e.target) && e.target !== gallery) return;
        var hit = null;
        gallery.querySelectorAll(".swiper-button").forEach(function (btn) {
          if (hit || btn.closest(".product__media-gallery-thumbails")) return;
          var r = btn.getBoundingClientRect();
          if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) hit = btn;
        });
        if (!hit) return;
        var label = (hit.getAttribute("aria-label") || "").toLowerCase();
        var isNext = /next|næste|højre|right/.test(label) || hit.matches(".swiper-button-next, [class*='button-next']");
        var last = sw.slides.length - 1;
        if (isNext && sw.activeIndex >= last) { e.preventDefault(); sw.slideTo(0); }
        else if (!isNext && sw.activeIndex <= 0) { e.preventDefault(); sw.slideTo(last); }
      }, true);
    })();

    /* the "fits" band says it in our own words, and the app re-renders the card whenever the garage
       changes — so keep setting it */
    (function () {
      var wrap = q("[data-pd-prows]"); var text = wrap && wrap.dataset.fitsSub;
      var pick = wrap && wrap.dataset.selectBike;
      /* "Skift MC" er et led i sætningen, ikke en pilleknap: "Denne del passer til dit køretøj ·
         Skift MC", hvor Skift MC er hvid, fed og understreget — præcis som "Se alle dele der
         passer" i banderollen når delen IKKE passer (merchant 2026-09-24). App-blokken tegner den
         som en knap i .fc-actions, så knappen FLYTTES (aldrig klones): så følger appens egen
         klik-håndtering med, og en gen-tegning af kortet lægger den bare tilbage, hvorefter det
         her kører igen. Idempotent, fordi vi kun leder efter knappen inde i .fc-actions. */
      var inlineChange = function () {
        document.querySelectorAll(".fc-band--fits, .fc-band--no-fit").forEach(function (band) {
          var sub = band.querySelector(".fc-sub"), btn = band.querySelector(".fc-actions [data-fc-open-garage]");
          if (!sub || !btn) return;
          var sep = document.createElement("span");
          sep.className = "fc-sub__sep"; sep.setAttribute("aria-hidden", "true"); sep.textContent = " · ";
          sub.appendChild(sep); sub.appendChild(btn);
        });
      };
      var apply = function () {
        if (text) document.querySelectorAll(".fc-band--fits .fc-sub").forEach(function (el) {
          var pos = el.querySelector(".fc-pos");
          if (el.dataset.pdSub === text) return;
          el.dataset.pdSub = text; el.textContent = text; if (pos) el.appendChild(pos);
        });
        inlineChange();   /* efter tekst-omskrivningen, som ellers ville rydde den flyttede knap */
        if (pick) document.querySelectorAll(".fc-band--no-vehicle [data-fc-open-garage]").forEach(function (b) {
          var span = b.querySelector("span") || b;                      /* keep the arrow icon */
          var node = Array.prototype.filter.call(b.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); })[0];
          if (node) { if (node.textContent.trim() !== pick) node.textContent = pick; }
          else if (span.textContent.trim() !== pick) span.textContent = pick;
        });
      };
      apply();
      var card = q(".fc-card"); if (card) new MutationObserver(apply).observe(card, { childList: true, subtree: true });
    })();

    /* the manufacturer logo belongs ON the photo, top-left (merchant 2026-09-11) — not in a box of its
       own above the title; the gallery is position:relative already */
    function onMedia(pill) {
      if (!pill || pill.dataset.pdOnMedia) return;
      var media = q(".product__media-wrapper") || q(".product__media-list") || q("media-gallery");
      if (!media) return;
      pill.dataset.pdOnMedia = "1";
      // The brand belongs at the TOP of the thumbnail column, in a box the size of a thumbnail, with
      // the photos below it (merchant 2026-09-11). The thumbnails live in a Swiper, so the box goes
      // BEFORE the swiper container — never inside its slide list, which Swiper counts.
      var item = media.querySelector(".product__thumbs-item, .thumbnail-list__item, [class*='thumbnail'] li");
      var strip = item && item.closest(".swiper-wrapper, .thumbnail-list");        /* the slide list */
      var column = strip && strip.parentElement;                                   /* the thumbs column (a Swiper) */
      if (item && strip && column) {
        var r = item.getBoundingClientRect();
        pill.classList.add("pd-brand-pill--thumb");
        pill.style.width = Math.round(r.width) + "px";
        pill.style.height = Math.round(r.height) + "px";
        column.classList.add("pd-thumbs-with-brand");
        column.insertBefore(pill, strip);   /* first box in the column, slides keep their own list */
        return;
      }
      // no thumbnails (single image): keep it on the photo, top-left
      var best = null, area = 0;
      media.querySelectorAll("img").forEach(function (im) { var b = im.getBoundingClientRect(); var a = b.width * b.height; if (a > area) { area = a; best = im; } });
      var host = best ? (best.closest(".product__media, .media, .product__media-item") || best.parentElement) : media;
      if (getComputedStyle(host).position === "static") host.style.position = "relative";
      pill.classList.add("pd-brand-pill--onmedia");
      host.appendChild(pill);
    }

    /* ---- brand logo in the brand pill (product-<slug>.jpg|png from the app's asset folder) ---- */
    var pill = q(".pd-brand-pill");
    var base = window.__pdBikeIcon;   // set by the fitment app block: …/assets/motorcycle_icon.png
    if (pill && base && /motorcycle_icon\.png/.test(base)) {
      var vendor = pill.textContent.trim();
      var slug = vendor.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
      if (slug) {
        var png = base.replace(/motorcycle_icon\.png/, "product-" + slug + ".png"), jpg = png.replace(/\.png(\?|$)/, ".jpg$1");
        var img = new Image(); img.alt = vendor; img.decoding = "async";
        img.onload = function () { pill.innerHTML = ""; pill.appendChild(img); pill.classList.add("pd-brand-pill--logo"); onMedia(pill); };
        img.onerror = function () { if (img.src === jpg) img.src = png; };   // jpg first (PE logos), then png; else keep the text
        img.src = jpg;
      }
    }
  });
})();

/* Recently viewed: remember this product's handle for the front page's product row. */
(function () {
  try {
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    var h = decodeURIComponent(m[1]);
    var list = JSON.parse(localStorage.getItem("pd_recent") || "[]");
    list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 12);
    localStorage.setItem("pd_recent", JSON.stringify(list));
  } catch (e) {}
})();
